import HeaderWithoutLogin from "../components/HeaderWithoutLogin";
import styled from "styled-components";
import MyGoalBody from "../components/MyGoalBody/MyGoalBody";

const BodyWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 1.5em;

  .formContainer {
    max-width: 800px;
    width: 100%;
    margin-top: 3%;
  }
`;

const MyGoal = () => {
  return (
    <>
      <HeaderWithoutLogin isLogOutButtonVisible={true} />
      <BodyWrapper>
        <div className="formContainer">
          <MyGoalBody />
        </div>
      </BodyWrapper>
    </>
  );
};

export default MyGoal;
